
import InfoCard from "../components/InfoCard/InfoCard"
import { useEffect, useState } from "react";

const GoldContainer = ({}) => {

    const [golden, setGolden] = useState([]);
  
    useEffect(() => {
      fetch("/templates/customWeb2/ModulesReact/buildInformationModule/data/golden.json")
        .then((res) => res.json())
        .then((data) => setGolden(data))
        .catch((err) => console.error("Error cargando golden.json:", err));
    }, []);

  return (
    <div style={{
        display: "grid",
        gridTemplateColumns: "repeat(3, 1fr)", // 3 columnas iguales
        gap: "20px", // espacio entre cartas
        width: "100%"}}>
        {golden.map((boss) =>(
            <InfoCard
                key={boss.name}
                imgSrc={boss.img}
                spanTag="Invasion"
                name={boss.name}
                mapRespawn={boss.map}
                drop={boss.drop}
                respawnTime = {boss.respawn}
                color="rgba(134, 116, 11, 1)"
            />
        ))
        }
    </div>
  )

}

export default GoldContainer